import React, { useState } from "react";
import { useSelector } from "react-redux";
import { selectCurrentUser } from "../../store/slices/currentUser";
import { Card, CardContent, Grid, Tabs, Tab, Box } from "@mui/material";
import StudentData from "../../components/student-data";
import StudentCourses from "../../components/student-courses";
import StudentPayments from "../../components/student-payments";
import StudentCoursesSummary from "../../components/student-courses-summary";
import StudentPaymentsSummary from "../../components/student-payment-summary";
import StudentSecurity from "../../components/student-security";
import StudentTicketsSummary from "../../components/student-tickets-summary";
import StudentTickets from "../../components/student-tickets";
import StudentSkeleton from "../../components/student-data/skeleton";
import {
  PersonOutline,
  LockOpen,
  AttachMoney,
  NotificationsNone,
  MenuBook,
} from "@mui/icons-material";
import StudentTagSummary from "../../components/student-tag-summary";
import { useLocation } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

//Provisional para crear el skeleton
const isLoading = false;

const StudentsPage = () => {
  const location = useLocation();
  const state = location.state;
  const { userId, businessId, clientId, roleId } = useSelector(selectCurrentUser);

  const [value, setValue] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const handleChange = (_, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%", overflowX: "hidden" }}>
      <Grid
        container
        pt="0px"
        spacing={2}
        sx={{
          height: "auto",
          marginBottom: 3,
          marginTop: 0,
          paddingBottom: 10,
        }}
      >
        <Grid item xs={12} md={4} sx={{ minWidth: 0, maxWidth: "100%" }}>
          <Card
            elevation={3}
            align="center"
            sx={{ height: "auto", width: "100%", overflow: "hidden" }}
          >
            {!isLoading ? (
              <>
                {state ? (
                  <StudentData userId={state.userId} />
                ) : (
                  <StudentData userId={userId} />
                )}
              </>
            ) : (
              <StudentSkeleton />
            )}
          </Card>
        </Grid>

        <Grid item xs={12} md={8} sx={{ minWidth: 0, maxWidth: "100%" }}>
          {!isLoading && (
            <Box sx={{ width: "100%", minWidth: 0 }}>
              <Box
                sx={{
                  backgroundColor: "white",
                  borderBottom: 1,
                  borderColor: "divider",
                  width: "100%",
                  maxWidth: { xs: "calc(100vw - 100px)", md: "100%" },
                  mb: 2,
                }}
              >
                <Tabs
                  value={value}
                  onChange={handleChange}
                  variant={isMobile ? "scrollable" : "standard"}
                  scrollButtons="auto"
                  allowScrollButtonsMobile
                  sx={{ "& .MuiTabs-flexContainer": { justifyContent: { xs: "flex-start", md: "center" } } }}
                >
                  <Tab
                    icon={<PersonOutline />}
                    label="RESUMEN"
                    iconPosition="start"
                  />
                  <Tab
                    icon={<MenuBook />}
                    label="CURSOS"
                    iconPosition="start"
                  />
                  <Tab
                    icon={<AttachMoney />}
                    label="PAGOS"
                    iconPosition="start"
                  />
                  <Tab
                    icon={<NotificationsNone />}
                    label="COMUNICACIONES"
                    iconPosition="start"
                  />
                  <Tab
                    icon={<LockOpen />}
                    label="SEGURIDAD"
                    iconPosition="start"
                  />
                </Tabs>
              </Box>

              {/* SUMMARY */}
              {value === 0 && (
                <Box sx={{ overflowX: "hidden" }}>
                  <Grid container spacing={2}>
                    {/* ******** ULTIMOS CURSOS ************ */}
                    <Grid item xs={12}>
                      <Card>
                        <CardContent>
                          {state ? (
                            <StudentCourses
                              businessId={state.studentId}
                              userId={state.userId}
                              isSummary={true}
                            />
                          ) : (
                            <StudentCourses
                              businessId={businessId}
                              userId={userId}
                              isSummary={true}
                            />
                          )}
                        </CardContent>
                      </Card>
                    </Grid>
                    {/* ******** ULTIMAS COMUNICACIONES ************ */}
                    <Grid item xs={12}>
                      <Card>
                        <CardContent>
                          {state ? (
                            <StudentTagSummary businessId={state.studentId} />
                          ) : (
                            <StudentTagSummary businessId={businessId} />
                          )}
                        </CardContent>
                      </Card>
                    </Grid>
                    {/* ******** ULTIMOS PAGOS ************ */}
                    <Grid item xs={12}>
                      <Card>
                        <CardContent>
                          {state ? (
                            <StudentPayments
                              isSummary={true}
                              businessId={state.studentId}
                              clientId={state.clientId}
                            />
                          ) : (
                            <StudentPayments
                              isSummary={true}
                              businessId={businessId}
                              clientId={clientId}
                            />
                          )}
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                </Box>
              )}
              {/* CURSOS */}
              {value === 1 && (
                <Box sx={{ overflowX: "hidden" }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Card>
                        <CardContent>
                          {state ? (
                            <StudentCoursesSummary
                              businessId={state.studentId}
                            />
                          ) : (
                            <StudentCoursesSummary businessId={businessId} />
                          )}
                        </CardContent>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Card>
                        <CardContent>
                          {state ? (
                            <StudentCourses
                              businessId={state.studentId}
                              isSummary={false}
                              userId={state.userId}
                              roleId={roleId}
                            />
                          ) : (
                            <StudentCourses
                              businessId={businessId}
                              isSummary={false}
                            />
                          )}
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                </Box>
              )}
              {/* PAGOS */}
              {value === 2 && (
                <Box sx={{ overflowX: "hidden" }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Card>
                        <CardContent>
                          {state ? (
                            <StudentPaymentsSummary
                              businessId={state.studentId}
                            />
                          ) : (
                            <StudentPaymentsSummary businessId={businessId} />
                          )}
                        </CardContent>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Card>
                        <CardContent>
                          {state ? (
                            <StudentPayments
                              isSummary={false}
                              businessId={state.studentId}
                              clientId={state.clientId}
                              roleId={roleId}
                            />
                          ) : (
                            <StudentPayments
                              isSummary={false}
                              businessId={businessId}
                              clientId={clientId}
                              roleId={roleId}
                            />
                          )}
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                </Box>
              )}
              {/* COMUNICACIONES */}
              {value === 3 && (
                <Box sx={{ overflowX: "hidden" }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Card>
                        <CardContent>
                          {state ? (
                            <StudentTicketsSummary
                              businessId={state.studentId}
                            />
                          ) : (
                            <StudentTicketsSummary businessId={businessId} />
                          )}
                        </CardContent>
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Card>
                        <CardContent>
                          {state ? (
                            <StudentTickets
                              businessId={state.studentId}
                              clientId={state.clientId}
                              roleId={roleId}
                            />
                          ) : (
                            <StudentTickets
                              businessId={businessId}
                              clientId={clientId}
                              roleId={roleId}
                            />
                          )}
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                </Box>
              )}
              {/* SEGURIDAD */}
              {value === 4 && (
                <Box sx={{ overflowX: "hidden" }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Card>
                        <CardContent>
                          {state ? (
                            <StudentSecurity
                              userId={state.userId}
                              username={state.username}
                              roleId={roleId}
                            />
                          ) : (
                            <StudentSecurity userId={userId} roleId={roleId} />
                          )}
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                </Box>
              )}
            </Box>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default StudentsPage;